/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/featuresSection.config.json";

import { useProduct } from "../provider";
import { toHeaderCase } from "js-convert-case";
import { camelCase } from "lodash";

export interface IProvenanceSectionMethods extends IPluginMethodMap {
    getProvenanceSectionProps(args: any): Promise<any>;
}

export class ProvenanceSectionService implements IAgentPlugin {
    readonly methods: IProvenanceSectionMethods;
    constructor() {
        this.methods = {
            getProvenanceSectionProps: this.getProps.bind(this),
        };
    }

    async getProps(args: any) {
        const _credTxs = args?.productData?.provenanceProdCreds?.data?.map((ele: any) => ele?.credTxId);
        if (!_credTxs || Array.isArray(_credTxs) && _credTxs.length === 0) {
            return {};
        }
        try {
            const res = await axios.post(`${args?.apiURL}/provenance/step_cred_bulk_V3/no_auth`, {
                gtin: args?.productData?.gtin,
                provId: args?.productData?.provenanceProdCreds?._id,
                credTxIds: _credTxs,
            });
            if (res?.data) {
                console.log(`productData`, res?.data);
                let _res = res?.data;
                return {
                    productData: {
                        ...args?.productData,
                        TIME_LINE_ITEMS: this.getTimeLine(_res),
                    }
                };
            }
        } catch (err: any) {
            console.log(`product Data`, err?.response?.data);
            throw Error(err?.response?.data?.error?.display_message);
        }
        // return { productData: { ...(config || {}) } };
    }

    private getTimeLine(data: any) {
        const groupedData = Object.values(
            data.reduce((acc: any, item: any) => {
                const title = item.ProvDetailInfo.title;
                if (!acc[title]) {
                    acc[title] = [];
                }
                acc[title].push(item);
                return acc;
            }, {})
        );
        console.log(groupedData);

        let _temp: any = [];
        Array.isArray(groupedData) && groupedData?.forEach(element => {
            if (Array.isArray(element) && element?.length > 0)
                _temp.push(
                    {
                        "key": element?.[0]?.credTxId,
                        "headline": toHeaderCase(element?.[0]?.ProvDetailInfo?.title ?? ""),
                        "headlineBackgroundColor": "#579783",
                        "children": this.getChildren(element)
                    }
                )
        });
        return _temp;
    }



    private getChildren(data: any) {
        let _temp: any = [];
        console.log(`data`, data);
        Array.isArray(data) && data.forEach(ele => {
            _temp.push({
                provenanceItem: ele,
                multiColList: this.getProvenanceAccordion(ele),
                "itemId": ele?.credTxId,
                "title": toHeaderCase(ele?.ProvDetailInfo?.title ?? ""),
                "subtitle": ele?.ProvDetailInfo?.aboutProvInfo,
                "carouselItems": ele?.ProvStepImages?.provImages?.length > 0 ? ele?.ProvStepImages?.provImages?.map((ele: any) => {
                    return {
                        src: ele?.image,
                        type: "img"
                    }
                }) : null,
                "carouselStyles": {
                    "width": "250px",
                    "height": "250px"
                },
                "badgeCarouselItems": this.getBadgeCarousel(ele?.badges)
            })
        });

        return _temp;
    }

    private getBadgeCarousel(data: any) {
        let _temp: any = [];
        Array.isArray(data) && data.forEach((element, index) => {
            _temp.push({
                batchData: element,
                key: element?.badgeName ? camelCase(element?.badgeName) : index + 1,
                titleImage:
                    element?.images &&
                        Array.isArray(element?.images) &&
                        element?.images.length > 0
                        ? element?.images[0]
                        : "https://i.ibb.co/WBztXW5/organic-logo-removebg-preview.png",
                title: element?.badgeName,
            });
        });

        return _temp;
    }


    private getProvenanceAccordion(res: any) {
        let _temp: any = [];
        if (res) {
            let _list: any = [];
            if (res?.org) {
                _list.push({
                    title: toHeaderCase("by"),
                    subTitle: res?.org?.name,
                })
            }
            Array.isArray(res?.ProvDetailInfo?.provInfoList) && res?.ProvDetailInfo?.provInfoList?.forEach((ele: any) => {
                _list.push({
                    title: toHeaderCase(ele?.label),
                    subTitle: ele?.value,
                })
            });
            _temp = [..._list]
        }
        return {
            "numberOfColumns": "2",
            data: _temp
        };
    }
}
